/* v8 ignore start */
export namespace ArrayUtils {
  export function create(size: number = 0): undefined[] {
    return Array(size).fill(undefined);
  }

  export function splitIntoChunks<T>(array: T[], size: number): T[][] {
    const chunks = [];
    let start;
    let j;

    for (start = 0, j = array.length; start < j; start += size) {
      chunks.push(array.slice(start, start + size));
    }

    return chunks;
  }
}
/* v8 ignore stop */
